import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { defer, findByKey } from '@thalesrc/js-utils';
import React, { useContext } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import Button from 'Common/Button';
import TextField from 'Common/Form/TextField';
import { SelectOptionsContext } from 'context/select-options.context';
import { useAsyncEffect, useUniqueId } from 'utils';

import DateInput from '../../../../../Common/Form/DateInput';
import { Vaccine } from './vaccine.model';

export interface VaccinateValues {
  date: string;
  lotNumber: string;
  description: string;
}

interface Props {
  opened: boolean;
  value: Vaccine;
  onClose(): any;
  onSubmit(value: VaccinateValues): any;
}

export default function Vaccinate({ opened, onClose, onSubmit, value }: Props) {
  const formId = useUniqueId('edit-vaccine-form');
  const { setValue, reset, trigger, ...methods } = useForm();
  const { vaccines } = useContext(SelectOptionsContext);

  useAsyncEffect(async () => {
    if (!opened) {
      return;
    }

    await defer();
    reset();
    setValue('date', value.date);
    setValue('lotNumber', value.lotNumber);
    setValue('description', value.description);
    trigger();
  }, [setValue, reset, trigger, opened, value]);

  return (
    <Dialog open={opened} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Aşı Kayıt - {findByKey(vaccines, 'value', value?.vaccineDefinitionId)?.text} - {value?.order}. Doz
      </DialogTitle>
      <DialogContent>
        <FormProvider {...{ setValue, trigger, reset, ...methods }}>
          <form id={formId} onSubmit={methods.handleSubmit(onSubmit)}>
            <DateInput name="date" label="Aşı Tarihi" type="date" required />
            <TextField name="lotNumber" label="LOT No" />
            <TextField name="description" label="Açıklama" rows={3} />
          </form>
        </FormProvider>
      </DialogContent>
      <DialogActions className="text-right pr-1 pb-2">
        <Button className="mr-2" onClick={onClose}>
          İptal
        </Button>
        <Button className="mr-2" color="primary" variant="contained" form={formId} type="submit">
          Kaydet
        </Button>
      </DialogActions>
    </Dialog>
  );
}
